document.addEventListener('DOMContentLoaded', () => {

  // Disable add button if out of stock
  document.querySelectorAll('.quick-add-qty-input').forEach((input) => {
    if (parseInt(input.max) <= 0) {
      input.closest('form')?.querySelector('.quick-add__submit')?.setAttribute('disabled', true);
    }
  });

  // +/- quantity buttons
  document.body.addEventListener('click', (e) => {
    if (e.target.classList.contains('quick-add-qty-minus')) {
      const input = e.target.nextElementSibling;
      if (parseInt(input.value) > 1) input.value = parseInt(input.value) - 1;
    }
    if (e.target.classList.contains('quick-add-qty-plus')) {
      const input = e.target.previousElementSibling;
      const productForm = e.target.closest('product-form');
      const max = parseInt(productForm?.dataset.inventory);
      if (isNaN(max) || parseInt(input.value) < max) input.value = parseInt(input.value) + 1;
}

  });

  // Intercept Add to Cart click
  document.body.addEventListener('click', async (e) => {
    const btn = e.target.closest('.quick-add__submit');
    if (!btn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const form = btn.closest('form');
    if (!form) return;

    const variantInput = form.querySelector('[name="id"]');
    const qtyInput = form.querySelector('.quick-add-qty-input');
    if (!variantInput) { console.error('No variant ID found'); return; }

    const variantId = variantInput.value;
    let qty = Math.min(parseInt(qtyInput?.value || 1), parseInt(qtyInput?.max) || Infinity);

    btn.disabled = true;
    const span = btn.querySelector('span:first-child');
    const originalText = span?.innerText;
    if (span) span.innerText = 'Adding...';

    try {
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: qty,
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname
        })
      });
      const addData = await addRes.json();

      if (span) span.innerText = '✓ Added';

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && addData.sections) {

        // Update cart icon bubble
        const bubbleEl = document.getElementById('cart-icon-bubble');
        if (bubbleEl && addData.sections['cart-icon-bubble']) {
          const parsed = new DOMParser().parseFromString(addData.sections['cart-icon-bubble'], 'text/html');
          const newBubble = parsed.querySelector('.shopify-section');
          if (newBubble) bubbleEl.innerHTML = newBubble.innerHTML;
        }

        // Render cart drawer without auto-opening
        const originalOpen = cartDrawer.open.bind(cartDrawer);
        cartDrawer.open = () => {};
        cartDrawer.renderContents({ id: addData.id, sections: addData.sections });

        // Force remove is-empty so products are visible
        cartDrawer.classList.remove('is-empty');
        cartDrawer.querySelector('.drawer__inner')?.classList.remove('is-empty');

        setTimeout(() => {
          cartDrawer.open = originalOpen;
          const overlay = document.getElementById('CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
        }, 200);
      }

    } catch(err) {
      console.error('Cart add failed:', err);
      if (span) span.innerText = 'Error';
    }

    setTimeout(() => {
      if (span) span.innerText = originalText;
      if (qtyInput) qtyInput.value = 1;
      btn.disabled = false;
    }, 2000);

  }, true);

  // Stock label above qty stepper
document.querySelectorAll('product-form').forEach(form => {
  const qty = parseInt(form.dataset.inventory);
  if (isNaN(qty)) return;
  const wrap = form.querySelector('.quick-add-qty-wrap');
  if (!wrap) return;
  const label = document.createElement('div');
  label.className = 'quick-add-stock-label';
  label.textContent = qty < 5 ? `Only ${qty} left!` : `${qty} available`;
  wrap.before(label);
});

});
